import styled, { css } from 'styled-components'

import { desktopCSS, tabletCSS } from '@measures/responsive'

const Title = styled.div`
  ${({
    theme: {
      colors: { staticWhite },
      typography: {
        headings: {
          xxsmall: { bundledCSS: xxsmallHeadingCSS },
          small: { bundledCSS: smallHeadingCSS },
          medium: { bundledCSS: mediumHeadingCSS },
        },
      },
      utils: { ellipsis },
    },
  }) => css`
    color: ${staticWhite};
    ${xxsmallHeadingCSS};
    line-height: 22.8px;

    ${ellipsis('100%', 2)};

    ${tabletCSS(css`
      ${smallHeadingCSS};
    `)}

    ${desktopCSS(css`
      ${mediumHeadingCSS};
    `)}
  `}
`

export default Title
